import { render, staticRenderFns } from "./TugendhatEdit.vue?vue&type=template&id=5c402561&scoped=true&"
import script from "./TugendhatEdit.vue?vue&type=script&lang=js&"
export * from "./TugendhatEdit.vue?vue&type=script&lang=js&"
import style0 from "./TugendhatEdit.vue?vue&type=style&index=0&id=5c402561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c402561",
  null
  
)

export default component.exports